const translations: Record<string, string> = {
  "ak_misc_select": "— select —",
  "ak_misc_empty": "Empty",
};

export default translations;
